import { useMemo } from 'react';
import { useFirebaseAuth } from './firebase.js';

/**
 * Hook that checks if the current user is an internal Zube user (has @getzube.com email).
 *
 * This is used to conditionally show internal-only features such as:
 * - Beta integrations (WhatsApp API, Facebook Messenger, Instagram)
 * - Debug/development tools
 * - Advanced configuration options
 *
 * This hook is used for both admin actions (impersonation, client management)
 * and feature visibility gating.
 *
 * @returns {object} Object containing isInternalUser boolean and email string
 */
export function useIsInternalUser() {
  const { user } = useFirebaseAuth();

  const isInternalUser = useMemo(() => {
    if (!user?.email) return false;
    return user.email.endsWith('@getzube.com');
  }, [user?.email]);

  const isFlaggedForReminders = !!user?.email;

  return {
    isInternalUser,
    isFlaggedForReminders,
    email: user?.email,
  };
}
